<div class="dialog-content">
  <div class="close" (click)="platoMcstegoDialogRef.close()"></div>

  <div class="external-wrapper" (click)="platoMcstegoDialogRef.close()"></div>

  <video controls poster="/assets/img/anatomy/tutorial-stegosaurus.png">
    <source src="/assets/videos/tutorial-stegosaurus.mp4" type="video/mp4">
    <img src="/assets/img/anatomy/tutorial-stegosaurus.png">
    Sorry, your browser doesn't support embedded videos.
  </video>
</div>
